import { HttpStatusCode } from '@angular/common/http';

export const NO_RESPONSE = 0;

export class HttpError<T = any> {
  readonly statusCode: HttpStatusCode | 0 = NO_RESPONSE;
  readonly message: string;
  readonly body: T;

  /** I'm aware about the use of 'any' type, but actually this can be any*/
  constructor(error: any) {
    this.statusCode = error?.status;
    this.body = error?.error;
    this.message = this.getErrorMessage(error);
  }

  private getErrorMessage(error: any) {
    return (
      error?.error?.data?.message ||
      error?.error?.error?.message ||
      error?.error?.message ||
      error?.message ||
      'Tivemos um problema ao processar a solicitação'
    );
  }
}
